import { ERoomType } from '@cian/api-models/common/json_query';
import { pathOr } from 'ramda';
import * as React from 'react';

import { useContext } from '../../../utils/useContext';
import { RoomType } from '../../../components/filters/RoomType';

export const RoomTypeContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useContext();
  const roomType = pathOr<ERoomType[]>([], ['room', 'value'], jsonQuery);

  const handleChange = React.useCallback(
    (roomType: ERoomType[]) => {
      onChange({ action: 'setRoomTypes', arguments: [roomType] });
      onApply();
    },
    [onChange, onApply],
  );

  return <RoomType value={roomType} onChange={handleChange} />;
};
